import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  NgbCarouselModule,
  NgbDropdownModule,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FormInputDirective } from './directives/form-input.directive';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LocalPaginationService } from './services/local-pagination.service';
import { TabContentDirective } from './directives/tab-content.directive';
import { NgxFileDropModule } from 'ngx-file-drop';

@NgModule({
  declarations: [FormInputDirective, TabContentDirective],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgbCarouselModule,
    FormInputDirective,
    NgxMaskDirective,
    NgxMaskPipe,
    NgbDropdownModule,
    TabContentDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgbDropdownModule,
    NgxFileDropModule,
  ],
  providers: [
    provideNgxMask(),
    LocalPaginationService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
